import 'css-chunksrc/client/scenes/assignToTask/projectSelection/zones/zone/projects/project/styles.scss';export default {
  "project": "_project_1ikz2_1",
  "icon": "_icon_1ikz2_11",
  "name": "_name_1ikz2_19"
};